"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const clear_theme_1 = require("./themes/clear-theme");
function ThemeProvider({ children }) {
    // TODO: logic to toggle theme based on user selection
    return (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, Object.assign({ theme: clear_theme_1.clearTheme }, { children: children }), void 0);
}
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=theme-provider.js.map